import { type FC, useState } from 'react';
import { useIntl, type MessageDescriptor } from 'dibs-react-intl';
import { Radio } from 'dibs-elements/exports/Radio.tsx';
import { Checkbox } from 'dibs-elements/exports/Checkbox.tsx';
import { ExpandingArea } from 'dibs-elements/exports/ExpandingArea.tsx';

import styles from './NftMarketMobileFacetSelect.scss';

type SingleSelectProps = {
    isMultiSelect: false;
    value: string | null;
    onChange: (newValue: string | null) => void;
};
type MultiSelectProps = {
    isMultiSelect: true;
    values: string[];
    onChange: (selectedValues?: string[]) => void;
};
type SelectProps = {
    label: string;
    dataTn: string;
    options: Array<{ value: string | null; label: MessageDescriptor }>;
} & (SingleSelectProps | MultiSelectProps);

export const NftMarketMobileFacetSelect: FC<SelectProps> = props => {
    const { label, dataTn, options } = props;
    const { formatMessage } = useIntl();
    const [isExpanded, setIsExpanded] = useState(true);

    return options.length === 0 ? null : (
        <ExpandingArea
            showArrow
            dataTn="facet-expanding-area"
            onClick={() => setIsExpanded(!isExpanded)}
            label={label}
            expanded={isExpanded}
            labelClass={styles.expandingAreaLabel}
            wrapperClass={styles.expandingArea}
        >
            {options.map(option => {
                const optionLabel = formatMessage(option.label);
                const sharedProps = {
                    label: optionLabel,
                    dataTn: `${dataTn}-option-${optionLabel}`,
                    name: `${dataTn}-option-${optionLabel}`,
                };

                let optionNode;
                if (props.isMultiSelect) {
                    const { values, onChange } = props;
                    optionNode = (
                        <Checkbox
                            checked={values.includes(option.value ?? '')}
                            onChange={(checked, e) => {
                                const selectionValue = e?.target.value;
                                if (checked && selectionValue) {
                                    onChange([...values, selectionValue]);
                                } else if (!checked && selectionValue) {
                                    onChange(values.filter(v => v !== selectionValue));
                                }
                            }}
                            value={option.value ?? ''}
                            {...sharedProps}
                        />
                    );
                } else {
                    const { value, onChange } = props;
                    optionNode = (
                        <Radio
                            checked={props.value === option.value || (!value && !option.value)}
                            onChange={selectedValue => onChange(selectedValue?.toString() ?? null)}
                            value={option.value ?? ''}
                            {...sharedProps}
                        />
                    );
                }

                return (
                    <div className={styles.optionContainer} key={option.value}>
                        {optionNode}
                    </div>
                );
            })}
        </ExpandingArea>
    );
};
